/**
 * 내보내기 기능 관련 타입 정의
 */

// 내보내기 포맷
export type ExportFormat = 'pdf' | 'jpg';

// 내보내기 범위
export type ExportScope = 'all' | 'viewport' | 'selection';

// PDF 용지 크기
export type PaperSize = 'A4' | 'Letter' | 'fit';

// PDF 용지 방향
export type PaperOrientation = 'portrait' | 'landscape';

// 이미지 품질
export type ImageQuality = 'low' | 'medium' | 'high';

// 이미지 스케일
export type ImageScale = 1 | 2 | 3;

// 내보내기 상태
export type ExportStatus = 'idle' | 'preparing' | 'capturing' | 'processing' | 'complete' | 'error';

// 기본 내보내기 옵션
export interface BaseExportOptions {
  format: ExportFormat;
  scope: ExportScope;
  filename: string;
}

// PDF 내보내기 옵션
export interface PDFExportOptions extends BaseExportOptions {
  format: 'pdf';
  paperSize: PaperSize;
  orientation: PaperOrientation;
  margin: number; // mm 단위
}

// JPG 내보내기 옵션
export interface JPGExportOptions extends BaseExportOptions {
  format: 'jpg';
  quality: ImageQuality;
  scale: ImageScale;
  backgroundColor: string;
}

// 통합 내보내기 옵션 타입
export type ExportOptions = PDFExportOptions | JPGExportOptions;

// 이미지 품질 값 매핑
export const IMAGE_QUALITY_MAP: Record<ImageQuality, number> = {
  low: 0.6,
  medium: 0.8,
  high: 1.0,
};

// 기본 PDF 옵션
export const DEFAULT_PDF_OPTIONS: PDFExportOptions = {
  format: 'pdf',
  scope: 'all',
  filename: 'notesense-export',
  paperSize: 'A4',
  orientation: 'landscape',
  margin: 10,
};

// 기본 JPG 옵션
export const DEFAULT_JPG_OPTIONS: JPGExportOptions = {
  format: 'jpg',
  scope: 'all',
  filename: 'notesense-export',
  quality: 'high',
  scale: 2,
  backgroundColor: '#ffffff',
};

// 내보내기 진행 상태
export interface ExportProgress {
  status: ExportStatus;
  progress: number; // 0-100
  message: string;
}

// 바운딩 박스 타입 (선택 영역 계산용)
export interface BoundingBox {
  minX: number;
  minY: number;
  maxX: number;
  maxY: number;
  width: number;
  height: number;
}
